import { render, staticRenderFns } from "./UnpostedDocumentsReport.vue?vue&type=template&id=6379e126"
import script from "./UnpostedDocumentsReport.vue?vue&type=script&lang=js"
export * from "./UnpostedDocumentsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports